import React, { useState, useEffect, useMemo, Fragment } from "react";
import { useNavigate } from "react-router-dom";

// import Page from "components/Page";
import SearchBar from "./SearchBar";
import RowCard from "./RowCard";

import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  SG_GET_SURVEY_STANDARDS,
  UPDATE_SURVEY_STANDARD_PAGE_NUMBER,
} from "constants/actions";

import { Button } from "components/ui/button";
import { Card, CardHeader, CardTitle, CardContent } from "components/ui/card";
import {
  Pagination as UiPagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
  PaginationEllipsis,
} from "components/ui/pagination";
import { Skeleton } from "components/ui/skeleton";

const List = ({ reload }) => {
  // employee_record_value
  const dispatch = useDispatch();
  let navigate = useNavigate();

  //   const [resetPageLoad, setResetPageLoad] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    // if the response is ok 200
    dispatch({
      type: SG_GET_SURVEY_STANDARDS,
      payload: `page=${page}${searchTerm ? `&search=${searchTerm}` : ""}`,
    });

    setLoading(true);
  }, [dispatch, page, searchTerm, reload]);

  const { get_survey_standard } = useSelector(
    (state) => ({
      get_survey_standard: state.survey_standard,
    }),
    shallowEqual
  );

  useEffect(() => {
    setResults(get_survey_standard?.survey_standard?.results);
    setPage(get_survey_standard?.pageNumber);
    setTotalPages(
      Math.ceil(
        get_survey_standard?.survey_standard?.count /
          get_survey_standard?.survey_standard?.page_size
      )
    );
  }, [get_survey_standard, page]);

  function handlePageChange(event, value) {
    setPage(value.activePage);
    dispatch({
      type: UPDATE_SURVEY_STANDARD_PAGE_NUMBER,
      payload: value.activePage,
    });
  }

  useEffect(() => {
    if (get_survey_standard?.pending === true) {
      setLoading(get_survey_standard?.pending);
    } else {
      const timer1 = setTimeout(() => {
        setLoading(get_survey_standard?.pending);
      }, 2000);
      return () => clearTimeout(timer1);
    }
  }, [get_survey_standard.pending]);

  const paginationItems = useMemo(() => {
    const pages = totalPages || 0;
    const current = Number(page) || 1;
    if (pages <= 1) return [];

    const items = [];
    const addPage = (p) => items.push({ type: "page", page: p, active: p === current });
    const addEllipsis = (key) => items.push({ type: "ellipsis", key });

    addPage(1);
    const start = Math.max(2, current - 1);
    const end = Math.min(pages - 1, current + 1);

    if (start > 2) addEllipsis("start");
    for (let p = start; p <= end; p += 1) addPage(p);
    if (end < pages - 1) addEllipsis("end");
    if (pages > 1) addPage(pages);
    return items;
  }, [page, totalPages]);

  const onPaginationClick = (e, nextPage) => {
    e?.preventDefault?.();
    handlePageChange(null, { activePage: nextPage });
  };

  return (
    <div className="max-w-7xl mx-auto p-4 md:p-6 space-y-4">
      <Card>
        <CardHeader className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <CardTitle className="text-xl md:text-2xl">Survey Standards</CardTitle>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              onClick={() => navigate("/app/survey-standard/app-survey-standards")}
            >
              View App Survey Standard
            </Button>
            <Button onClick={() => navigate("/app/survey-standard/create")}>Create</Button>
          </div>
        </CardHeader>
        <CardContent>
          <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </CardContent>
      </Card>

      <Card id="results">
        <CardContent className="p-0">
          {loading ? (
            <div className="p-6 space-y-3">
              <Skeleton className="h-6 w-48" />
              <Skeleton className="h-10 w-full" />
              <Skeleton className="h-10 w-full" />
              <Skeleton className="h-10 w-full" />
            </div>
          ) : results && results.length > 0 ? (
            <RowCard rows={results} />
          ) : (
            <div className="p-10 text-center">
              <p className="text-sm text-muted-foreground mb-4">No survey standards found.</p>
              <div className="flex items-center justify-center gap-2">
                <Button variant="outline" onClick={() => setSearchTerm("")}>Clear search</Button>
                <Button onClick={() => navigate("/app/survey-standard/create")}>Create new</Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>

      {totalPages > 1 && (
        <UiPagination>
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious
                href="#"
                onClick={(e) => onPaginationClick(e, Math.max(1, Number(page) - 1))}
              />
            </PaginationItem>

            {paginationItems.map((item, idx) => (
              <Fragment key={idx}>
                {item.type === "ellipsis" ? (
                  <PaginationItem>
                    <PaginationEllipsis />
                  </PaginationItem>
                ) : (
                  <PaginationItem>
                    <PaginationLink
                      href="#"
                      isActive={item.active}
                      onClick={(e) => onPaginationClick(e, item.page)}
                    >
                      {item.page}
                    </PaginationLink>
                  </PaginationItem>
                )}
              </Fragment>
            ))}

            <PaginationItem>
              <PaginationNext
                href="#"
                onClick={(e) => onPaginationClick(e, Math.min(totalPages, Number(page) + 1))}
              />
            </PaginationItem>
          </PaginationContent>
        </UiPagination>
      )}
    </div>
  );
};

export default List;
